import React from "react";
import PageBanner from "../Shared/PageBanner";
import bannerBg from "../assets/img/Banner/Top-Image6.jpg";
import Recommended from "../components/ResultsPage/Recommended";
import SelectLevel from "../components/ResultsPage/SelectLevel";
import ReportsRecommended from "../components/ResultsPage/ReportsRecommended";
import { useTranslation } from "react-i18next";
import { useFetchLinksQuery } from "../app/feature/API/Helpers";

const ResultPage = () => {
  const {i18n} = useTranslation()
  const {data:HeaderLink} = useFetchLinksQuery()
  const isShowReport = HeaderLink?.some(
    (e) => e?.title === "Industry Reports" && e?.show_link !== 0
  );
  return (
    <>
      <PageBanner
        currentPage={i18n.language==='en'?"Smart Service Request":"طلب الخدمة الذكية"}
        title={i18n.language==='en'?"Smart Service Request":"طلب الخدمة الذكية"}
        bannerBg={bannerBg}
      />
      <Recommended/>
      <SelectLevel/>
      {isShowReport&&<ReportsRecommended/>}
    </>
  );
};

export default React.memo(ResultPage);
